import {破棄破損修正候補編集レコード型} from '@/type/destroy/records/modify/破棄破損修正候補編集レコード型';

export interface 破棄破損修正依頼一覧型 {
  破棄破損修正依頼一覧: 破棄破損修正依頼型[];
}

interface 破棄破損修正依頼型 {
  部署コード: string;
  商品コード: string;
  破棄破損シーケンス番号: number;
  破棄破損伝票番号: number;
  破棄破損伝票行番号: number;
  破棄破損日: Date;
  破棄破損箱数: number;
  破棄破損バラ数: number;
  破棄破損有効期限: Date;
  破棄破損入力方法区分: string;
  破棄破損理由: string;
  破棄破損部署コード: string;
  破棄破損コメント: string;
  入数: number;
  更新バージョン: number;
}

export function to破棄破損修正依頼一覧型(部署コード: string, records: 破棄破損修正候補編集レコード型[]): 破棄破損修正依頼一覧型 {
  return {
    破棄破損修正依頼一覧: records.map((record) => to破棄破損修正依頼型(部署コード, record)),
  };
}

function to破棄破損修正依頼型(部署コード: string, record: 破棄破損修正候補編集レコード型): 破棄破損修正依頼型 {
  return {
    部署コード,
    商品コード: record.元レコード.商品コード,
    破棄破損シーケンス番号: record.元レコード.破棄破損シーケンス番号,
    破棄破損伝票番号: record.元レコード.破棄破損伝票番号,
    破棄破損伝票行番号: record.元レコード.破棄破損伝票行番号,
    破棄破損日: record.破棄破損日,
    破棄破損箱数: record.破棄破損箱数,
    破棄破損バラ数: record.破棄破損バラ数,
    破棄破損有効期限: record.元レコード.破棄破損有効期限,
    破棄破損入力方法区分: record.元レコード.破棄破損入力方法区分,
    破棄破損理由: record.破棄破損理由,
    破棄破損部署コード: record.破棄破損部署コード,
    破棄破損コメント: record.破棄破損コメント,
    入数: record.元レコード.入数,
    更新バージョン: record.元レコード.更新バージョン,
  };
}
